var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 
 * @file Content Sidebar Component
 * @author Box
 */

import 'regenerator-runtime/runtime';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import uniqueid from 'lodash/uniqueId';
import noop from 'lodash/noop';
import LoadingIndicator from 'box-react-ui/lib/components/loading-indicator/LoadingIndicator';
import Sidebar from './Sidebar';
import API from '../../api';
import APIContext from '../APIContext';
import Internationalize from '../Internationalize';
import { SIDEBAR_FIELDS_TO_FETCH } from '../../util/fields';
import { DEFAULT_HOSTNAME_API, CLIENT_NAME_CONTENT_SIDEBAR, SIDEBAR_VIEW_SKILLS, SIDEBAR_VIEW_ACTIVITY, SIDEBAR_VIEW_DETAILS, SIDEBAR_VIEW_METADATA } from '../../constants';
import SidebarUtils from './SidebarUtils'; // eslint-disable-line

var ContentSidebar = function (_PureComponent) {
    _inherits(ContentSidebar, _PureComponent);

    /**
     * [constructor]
     *
     * @private
     * @return {ContentSidebar}
     */
    function ContentSidebar(props) {
        _classCallCheck(this, ContentSidebar);

        var _this = _possibleConstructorReturn(this, (ContentSidebar.__proto__ || Object.getPrototypeOf(ContentSidebar)).call(this, props));

        _this.initialState = {
            file: undefined
        };

        _this.onToggle = function (view) {
            var stateView = _this.state.view;

            var isTogglingOff = view === stateView;
            var isTogglingOn = !stateView && !!view;
            var isToggling = isTogglingOff || isTogglingOn;
            _this.setState({
                view: isTogglingOff ? undefined : view,
                hasBeenToggled: isToggling
            });
        };

        _this.errorCallback = function (error) {
            /* eslint-disable no-console */
            console.error(error);
            /* eslint-enable no-console */
        };

        _this.fetchFileSuccessCallback = function (file) {
            if (SidebarUtils.shouldRenderSidebar(_this.props, file)) {
                _this.setState({
                    file: file,
                    isVisible: true,
                    view: _this.getDefaultSidebarView(file, _this.props)
                });
            } else {
                _this.setState({ isVisible: false });
            }
        };

        var cache = props.cache,
            token = props.token,
            sharedLink = props.sharedLink,
            sharedLinkPassword = props.sharedLinkPassword,
            apiHost = props.apiHost,
            clientName = props.clientName,
            requestInterceptor = props.requestInterceptor,
            responseInterceptor = props.responseInterceptor;


        _this.id = uniqueid('bcs_');
        _this.api = new API({
            cache: cache,
            token: token,
            sharedLink: sharedLink,
            sharedLinkPassword: sharedLinkPassword,
            apiHost: apiHost,
            clientName: clientName,
            requestInterceptor: requestInterceptor,
            responseInterceptor: responseInterceptor
        });

        // Clone initial state to allow for state reset on new files
        _this.state = _extends({}, _this.initialState);
        return _this;
    }

    /**
     * Destroys api instances with caches
     *
     * @private
     * @return {void}
     */


    _createClass(ContentSidebar, [{
        key: 'clearCache',
        value: function clearCache() {
            this.api.destroy(true);
        }

        /**
         * Cleanup
         *
         * @private
         * @inheritdoc
         * @return {void}
         */

    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // Don't destroy the cache while unmounting
            this.api.destroy(false);
        }

        /**
         * Fetches the root folder on load
         *
         * @private
         * @inheritdoc
         * @return {void}
         */

    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchData(this.props);
        }

        /**
         * Called when sidebar gets new properties
         *
         * @private
         * @return {void}
         */

    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props = this.props,
                fileId = _props.fileId,
                isLarge = _props.isLarge;
            var _state = this.state,
                file = _state.file,
                hasBeenToggled = _state.hasBeenToggled;

            var hasVisibilityChanged = nextProps.isLarge !== isLarge;
            var hasFileIdChanged = nextProps.fileId !== fileId;

            if (hasFileIdChanged) {
                // Clear out existing state
                this.setState(_extends({}, this.initialState));
                this.fetchData(nextProps);
            } else if (!hasBeenToggled && hasVisibilityChanged) {
                this.setState({
                    view: this.getDefaultSidebarView(file, nextProps)
                });
            }
        }

        /**
         * Toggle the sidebar view state
         *
         * @param {string} view - the selected view
         * @return {void}
         */

    }, {
        key: 'fetchData',


        /**
         * Fetches the file data for the sidebar
         *
         * @param {Object} Props the component props
         * @return {void}
         */
        value: function fetchData(props) {
            var fileId = props.fileId;

            if (fileId && SidebarUtils.canHaveSidebar(props)) {
                // Fetch the new file
                this.fetchFile(fileId);
            }
        }

        /**
         * Network error callback
         *
         * @private
         * @param {Error} error - Error object
         * @return {void}
         */

    }, {
        key: 'getDefaultSidebarView',


        /**
         * File fetch success callback that sets the file and view
         *
         * @private
         * @param {Object} props - component props
         * @param {Object} file - Box file
         * @return {string} Sidebar view to use
         */
        value: function getDefaultSidebarView(file, props) {
            var _state2 = this.state,
                view = _state2.view,
                hasBeenToggled = _state2.hasBeenToggled;
            var isLarge = props.isLarge,
                defaultView = props.defaultView;

            // If no file we don't have a view

            if (!file) {
                return undefined;
            }

            // If there was a default view provided, force use that
            if (defaultView) {
                return defaultView;
            }

            // If the user manually toggled the sidebar, respect that.
            // Otherwise use responsiveness to determine default view.
            if (!hasBeenToggled && !isLarge) {
                return undefined;
            }

            var newView = void 0;
            var canDefaultToSkills = SidebarUtils.shouldRenderSkillsSidebar(this.props, file);
            var canDefaultToDetails = SidebarUtils.canHaveDetailsSidebar(this.props);
            var canDefaultToActivity = SidebarUtils.canHaveActivitySidebar(this.props);
            var canDefaultToMetadata = SidebarUtils.canHaveMetadataSidebar(this.props);

            // Calculate the default view with latest props
            if (canDefaultToSkills) {
                newView = SIDEBAR_VIEW_SKILLS;
            } else if (canDefaultToActivity) {
                newView = SIDEBAR_VIEW_ACTIVITY;
            } else if (canDefaultToDetails) {
                newView = SIDEBAR_VIEW_DETAILS;
            } else if (canDefaultToMetadata) {
                newView = SIDEBAR_VIEW_METADATA;
            }

            // Only reset the view if prior view is no longer applicable
            if (!view || view === SIDEBAR_VIEW_SKILLS && !canDefaultToSkills || view === SIDEBAR_VIEW_ACTIVITY && !canDefaultToActivity || view === SIDEBAR_VIEW_DETAILS && !canDefaultToDetails || view === SIDEBAR_VIEW_METADATA && !canDefaultToMetadata) {
                return newView;
            }

            return view;
        }

        /**
         * File fetch success callback that sets the file and view
         * Only set file if there is data to show in the sidebar.
         * Skills sidebar doesn't show when there is no data.
         *
         * @private
         * @param {Object} file - Box file
         * @return {void}
         */

    }, {
        key: 'fetchFile',


        /**
         * Fetches a file
         *
         * @private
         * @param {string} id - File id
         * @param {Object|void} [fetchOptions] - Fetch options
         * @return {void}
         */
        value: function fetchFile(id) {
            var fetchOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (SidebarUtils.canHaveSidebar(this.props)) {
                this.api.getFileAPI().getFile(id, this.fetchFileSuccessCallback, this.errorCallback, _extends({}, fetchOptions, {
                    fields: SIDEBAR_FIELDS_TO_FETCH
                }));
            }
        }

        /**
         * Renders the sidebar
         *
         * @private
         * @inheritdoc
         * @return {Element}
         */

    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props2 = this.props,
                language = _props2.language,
                messages = _props2.messages,
                getPreview = _props2.getPreview,
                getViewer = _props2.getViewer,
                hasActivityFeed = _props2.hasActivityFeed,
                className = _props2.className,
                activitySidebarProps = _props2.activitySidebarProps,
                detailsSidebarProps = _props2.detailsSidebarProps,
                metadataSidebarProps = _props2.metadataSidebarProps,
                onVersionHistoryClick = _props2.onVersionHistoryClick;
            var _state3 = this.state,
                file = _state3.file,
                view = _state3.view,
                isVisible = _state3.isVisible;

            // By default sidebar is always visible if there is something configured
            // to show via props. At least one of the sidebars is needed for visibility.
            // However we may turn the visibility off if there is no data to show
            // in the sidebar. This can only happen if skills sidebar was showing
            // however there is no skills data to show. For all other sidebars
            // we show them by default even if there is no data in them.

            if (!isVisible || !SidebarUtils.canHaveSidebar(this.props)) {
                return null;
            }

            var styleClassName = classNames('be bcs', (_classNames = {}, _defineProperty(_classNames, 'bcs-' + view, !!view), _defineProperty(_classNames, 'bcs-is-open', !!view), _classNames), className);

            var hasSkills = SidebarUtils.shouldRenderSkillsSidebar(this.props, file);
            var hasDetails = SidebarUtils.canHaveDetailsSidebar(this.props);
            var hasMetadata = SidebarUtils.canHaveMetadataSidebar(this.props);
            var hasSidebar = SidebarUtils.shouldRenderSidebar(this.props, file);

            return React.createElement(
                Internationalize,
                { language: language, messages: messages },
                React.createElement(
                    'aside',
                    { id: this.id, className: styleClassName },
                    React.createElement(
                        'div',
                        { className: 'be-app-element' },
                        hasSidebar ? React.createElement(
                            APIContext.Provider,
                            { value: this.api },
                            React.createElement(Sidebar, {
                                file: file,
                                view: view,
                                detailsSidebarProps: detailsSidebarProps,
                                activitySidebarProps: activitySidebarProps,
                                metadataSidebarProps: metadataSidebarProps,
                                getPreview: getPreview,
                                getViewer: getViewer,
                                hasSkills: hasSkills,
                                hasDetails: hasDetails,
                                hasMetadata: hasMetadata,
                                hasActivityFeed: hasActivityFeed,
                                onToggle: this.onToggle,
                                onVersionHistoryClick: onVersionHistoryClick
                            })
                        ) : React.createElement(
                            'div',
                            { className: 'bcs-loading' },
                            React.createElement(LoadingIndicator, null)
                        )
                    )
                )
            );
        }
    }]);

    return ContentSidebar;
}(PureComponent);

ContentSidebar.defaultProps = {
    className: '',
    clientName: CLIENT_NAME_CONTENT_SIDEBAR,
    apiHost: DEFAULT_HOSTNAME_API,
    getPreview: noop,
    getViewer: noop,
    isLarge: true,
    hasSkills: false,
    hasMetadata: false,
    hasActivityFeed: false,
    activitySidebarProps: {},
    detailsSidebarProps: {},
    metadataSidebarProps: {}
};

export default ContentSidebar;